import { BaseResponse } from '@/domain/entities/BaseResponse'
import { AxiosResponse } from 'axios'

export class BaseResponseMapper {
  public convertBaseResponseFromApi<T>(
    result: AxiosResponse<any>
  ): BaseResponse<T> {
    const { data } = result
    return new BaseResponse(
      data.success,
      data.message,
      data.deleted_ids,
      data.data
    )
  }
}
